/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as R404RouteImport } from './routes/404'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AppTestsRouteImport } from './routes/app-tests'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MyBidsRouteImport } from './routes/my-bids'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PaymentSuccessRouteImport } from './routes/payment-success'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SubmitTestRouteImport } from './routes/submit-test'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as WebappTestsRouteImport } from './routes/webapp-tests'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AppTestsRoute = AppTestsRouteImport.update({
  id: '/app-tests',
  path: '/app-tests',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MyBidsRoute = MyBidsRouteImport.update({
  id: '/my-bids',
  path: '/my-bids',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
  id: '/payment-success',
  path: '/payment-success',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SubmitTestRoute = SubmitTestRouteImport.update({
  id: '/submit-test',
  path: '/submit-test',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TestimonialsRoute = TestimonialsRouteImport.update({
  id: '/testimonials',
  path: '/testimonials',
  getParentRoute: () => rootRouteImport,
} as any)
const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const WebappTestsRoute = WebappTestsRouteImport.update({
  id: '/webapp-tests',
  path: '/webapp-tests',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/app-tests': typeof AppTestsRoute
  '/contact': typeof ContactRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-bids': typeof MyBidsRoute
  '/onboarding': typeof OnboardingRoute
  '/payment-success': typeof PaymentSuccessRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/signup': typeof SignupRoute
  '/submit-test': typeof SubmitTestRoute
  '/terms': typeof TermsRoute
  '/testimonials': typeof TestimonialsRoute
  '/wallet': typeof WalletRoute
  '/webapp-tests': typeof WebappTestsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/app-tests': typeof AppTestsRoute
  '/contact': typeof ContactRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-bids': typeof MyBidsRoute
  '/onboarding': typeof OnboardingRoute
  '/payment-success': typeof PaymentSuccessRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/signup': typeof SignupRoute
  '/submit-test': typeof SubmitTestRoute
  '/terms': typeof TermsRoute
  '/testimonials': typeof TestimonialsRoute
  '/wallet': typeof WalletRoute
  '/webapp-tests': typeof WebappTestsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/404': typeof R404Route
  '/about': typeof AboutRoute
  '/app-tests': typeof AppTestsRoute
  '/contact': typeof ContactRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-bids': typeof MyBidsRoute
  '/onboarding': typeof OnboardingRoute
  '/payment-success': typeof PaymentSuccessRoute
  '/privacy': typeof PrivacyRoute
  '/profile': typeof ProfileRoute
  '/signup': typeof SignupRoute
  '/submit-test': typeof SubmitTestRoute
  '/terms': typeof TermsRoute
  '/testimonials': typeof TestimonialsRoute
  '/wallet': typeof WalletRoute
  '/webapp-tests': typeof WebappTestsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/about'
    | '/app-tests'
    | '/contact'
    | '/faq'
    | '/forgot-password'
    | '/login'
    | '/my-bids'
    | '/onboarding'
    | '/payment-success'
    | '/privacy'
    | '/profile'
    | '/signup'
    | '/submit-test'
    | '/terms'
    | '/testimonials'
    | '/wallet'
    | '/webapp-tests'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/about'
    | '/app-tests'
    | '/contact'
    | '/faq'
    | '/forgot-password'
    | '/login'
    | '/my-bids'
    | '/onboarding'
    | '/payment-success'
    | '/privacy'
    | '/profile'
    | '/signup'
    | '/submit-test'
    | '/terms'
    | '/testimonials'
    | '/wallet'
    | '/webapp-tests'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/about'
    | '/app-tests'
    | '/contact'
    | '/faq'
    | '/forgot-password'
    | '/login'
    | '/my-bids'
    | '/onboarding'
    | '/payment-success'
    | '/privacy'
    | '/profile'
    | '/signup'
    | '/submit-test'
    | '/terms'
    | '/testimonials'
    | '/wallet'
    | '/webapp-tests'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  AboutRoute: typeof AboutRoute
  AppTestsRoute: typeof AppTestsRoute
  ContactRoute: typeof ContactRoute
  FaqRoute: typeof FaqRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MyBidsRoute: typeof MyBidsRoute
  OnboardingRoute: typeof OnboardingRoute
  PaymentSuccessRoute: typeof PaymentSuccessRoute
  PrivacyRoute: typeof PrivacyRoute
  ProfileRoute: typeof ProfileRoute
  SignupRoute: typeof SignupRoute
  SubmitTestRoute: typeof SubmitTestRoute
  TermsRoute: typeof TermsRoute
  TestimonialsRoute: typeof TestimonialsRoute
  WalletRoute: typeof WalletRoute
  WebappTestsRoute: typeof WebappTestsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app-tests': {
      id: '/app-tests'
      path: '/app-tests'
      fullPath: '/app-tests'
      preLoaderRoute: typeof AppTestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-bids': {
      id: '/my-bids'
      path: '/my-bids'
      fullPath: '/my-bids'
      preLoaderRoute: typeof MyBidsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment-success': {
      id: '/payment-success'
      path: '/payment-success'
      fullPath: '/payment-success'
      preLoaderRoute: typeof PaymentSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/submit-test': {
      id: '/submit-test'
      path: '/submit-test'
      fullPath: '/submit-test'
      preLoaderRoute: typeof SubmitTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/testimonials': {
      id: '/testimonials'
      path: '/testimonials'
      fullPath: '/testimonials'
      preLoaderRoute: typeof TestimonialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webapp-tests': {
      id: '/webapp-tests'
      path: '/webapp-tests'
      fullPath: '/webapp-tests'
      preLoaderRoute: typeof WebappTestsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  AboutRoute: AboutRoute,
  AppTestsRoute: AppTestsRoute,
  ContactRoute: ContactRoute,
  FaqRoute: FaqRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MyBidsRoute: MyBidsRoute,
  OnboardingRoute: OnboardingRoute,
  PaymentSuccessRoute: PaymentSuccessRoute,
  PrivacyRoute: PrivacyRoute,
  ProfileRoute: ProfileRoute,
  SignupRoute: SignupRoute,
  SubmitTestRoute: SubmitTestRoute,
  TermsRoute: TermsRoute,
  TestimonialsRoute: TestimonialsRoute,
  WalletRoute: WalletRoute,
  WebappTestsRoute: WebappTestsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
